/**
 * The consent notice generation the HubSpot banner source records decisions under.
 *
 * Unlike the c15t generation (`../c15t/consentNotice.version.ts`), the copy this id names is
 * NOT compiled into this bundle: HubSpot renders its banner from the cookie policy published
 * in the HubSpot portal for the hostname. What this repo can commit is a dated snapshot of
 * that copy (`./hubspotNotice.snapshot.md`), so the id resolves to wording someone captured on
 * that day — not to wording a checksum proves every visitor saw. A portal edit changes what
 * visitors read without touching this id, and HubSpot does not re-prompt for a bump of it:
 * HubSpot's own choice cookie is what makes a visitor decided, so a bump here re-records
 * their existing HubSpot answer under the new id rather than asking again.
 *
 * `Scripts/check-consent-notice-version-lockstep.py` fails when this value and the backend
 * constant disagree while this is the mounted source's id (see `engine/consentNotice.ts`).
 * Bumping it means: re-snapshot the portal copy, change this value, add the backend
 * constant and point `Current` at it — in one commit. Procedure and caveats:
 * `docs/ageless/consent-notice-versions.md`.
 */
export const HUBSPOT_CONSENT_NOTICE_VERSION = "hubspot-banner-2026-09-15";

/**
 * The language HubSpot's notice is PRESENTED in. The portal policy carries one English
 * wording and shows it regardless of the route locale (`./hubspotNotice.snapshot.md`,
 * "Language"), so a decision made on `/es-MX` was still read in English and is recorded
 * as such — the record names the notice's language, never the page's.
 */
export const HUBSPOT_CONSENT_NOTICE_LANGUAGE = "en_US";

/** Resolves the recorded notice language for a route locale: always English for this banner. */
export const resolveHubSpotNoticeLanguage = (): string => HUBSPOT_CONSENT_NOTICE_LANGUAGE;
